import {
  ADDED,
  DELETED,
  FILTERED,
  IDADDED,
  LOADED,
  SEARCHED,
  UPDATED,
} from './actionTypes';

export const loaded = (books) => {
  return {
    type: LOADED,
    payload: books,
  };
};

export const added = (book) => {
  return {
    type: ADDED,
    payload: book,
  };
};

export const updated = (book) => {
  return {
    type: UPDATED,
    payload: book,
  };
};

export const idAdded = (id) => {
  return {
    type: IDADDED,
    payload: id,
  };
};

export const deleted = (id) => {
  return {
    type: DELETED,
    payload: id,
  };
};

export const filtered = (category) => {
  return {
    type: FILTERED,
    payload: category,
  };
};

export const searched = (text) => {
  return {
    type: SEARCHED,
    payload: text,
  };
};
